const {databaseServer} = require("../config/network");

const getStates = async () => {
    return fetch(`${databaseServer}/states`)
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    getStates
}